import { render, staticRenderFns } from "./ProfilePopoverCard.vue?vue&type=template&id=3f209efb&scoped=true"
import script from "./ProfilePopoverCard.vue?vue&type=script&lang=js"
export * from "./ProfilePopoverCard.vue?vue&type=script&lang=js"
import style0 from "./ProfilePopoverCard.vue?vue&type=style&index=0&id=3f209efb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f209efb",
  null
  
)

export default component.exports